import { jsx as _jsx } from "react/jsx-runtime";
import CheckIconSvg from '@assets/icons/check-icon.svg';
const CheckIcon = () => {
    return (_jsx("img", { src: CheckIconSvg, alt: "check-icon" }));
};
export default CheckIcon;
